import { Component } from '@angular/core';

@Component({templateUrl: 'error-500.component.html'})
export class Error500Component {}
